import 'react-i18next';
import ar from '../../i18n/locales/ar.json';
import en from '../../i18n/locales/en.json';

export enum LanguageCodes {
  AR = 'ar',
  EN = 'en',
}

// Custom type for the translations
interface I18nNamespaces {
  translation: typeof ar & typeof en;
}

declare module 'react-i18next' {
  interface CustomTypeOptions {
    defaultNS: 'translation';
    resources: I18nNamespaces;
  }
}
